'use strict';

var configureStorePrd = require('./configureStore.prod');
var configureStoreDev = require('./configureStore.dev');

if (process.env.NODE_ENV === 'production') {
  module.exports = configureStorePrd;
} else {
  module.exports = configureStoreDev;
}